import { useCallback } from 'react';
import { useFormatter } from 'js/hooks/useFormatter';

export const useDownloadCSV = () => {
    const formatter = useFormatter();

    return useCallback(({ fileName, csv, startDate, endDate }) => {
        const period = `${formatter.getDateForCsv(startDate)}_${formatter.getDateForCsv(endDate)}`;
        const filename = `${fileName}_${period}.csv`;
        const link = document.createElement('a');

        link.setAttribute('download', filename);
        link.setAttribute('href', csv);
        link.click();
    }, [formatter]);
};
